import gql from "graphql-tag";

export const parseFecha = (f='', horas = false) => {
    if(!f) return '';
    if(!horas){
        return f.split('T')[0].split('-').reverse().join('/')
    }
    return f;
}

export const parseDateFecha = (f = '', horas = false) => {
    if (!f) return ''; // Si no hay fecha, devuelve una cadena vacía

    const date = new Date(f); // Convierte la cadena de fecha a un objeto Date

    if (isNaN(date.getTime())) {
        return ''; // Si la fecha no es válida, devuelve una cadena vacía
    }

    const day = String(date.getDate()).padStart(2, '0'); // dd
    const month = String(date.getMonth() + 1).padStart(2, '0'); // MM (los meses van de 0 a 11)
    const year = date.getFullYear(); // yyyy

    let str = `${day}/${month}/${year}`; // Formato base: dd/MM/yyyy

    if (horas) {
        const hours = String(date.getHours()).padStart(2, '0'); // HH
        const minutes = String(date.getMinutes()).padStart(2, '0'); // mm
        str += ` ${hours}:${minutes}`; // Agrega HH:mm al formato base
    }

    return str; 
};

export const meses = () => {
    return [
        { id: 0, text: 'Sin seleccionar' },
        { id: 1, text: 'enero' },
        { id: 2, text: 'febrero' },
        { id: 3, text: 'marzo' },
        { id: 4, text: 'abril' },
        { id: 5, text: 'mayo' },
        { id: 6, text: 'junio' },
        { id: 7, text: 'julio' },
        { id: 8, text: 'agosto' },
        { id: 9, text: 'septiembre' },
        { id: 10, text: 'octubre' },
        { id: 11, text: 'noviembre' },
        { id: 12, text: 'diciembre' }
    ];
};

export const gestionesAsync = async (vue) => {
    const sql = gql`query{getGestiones{gestion,apertura,cierre}}`;
    const res = await vue.$apollo.query({ query: sql }).then(({data})=>data).catch(e=>e);
    const gs = [];
    gs.push({id:0, text:'Sin seleccionar'});
    res.getGestiones.reverse().forEach(g => {
        gs.push({id:g.gestion, text:''+g.gestion})
    });
    return gs;
}